import React from 'react'
import { Box, Button, Typography } from '@mui/material'

interface MobileEnquiryBarProps {
    priceLabel: string
    /** Pre-formatted, e.g. 'AED 10,599'. */
    price: string
    ctaLabel: string
    onCtaClick: () => void
}

/**
 * The phone counterpart to the desktop sticky enquiry card: a docked bar carrying the headline
 * price and a jump to the form, so the call to action stays reachable through a long itinerary.
 */
const MobileEnquiryBar: React.FC<MobileEnquiryBarProps> = ({ priceLabel, price, ctaLabel, onCtaClick }) => {
    return (
        <Box
            onClick={onCtaClick}
            sx={{
                cursor: 'pointer',
                position: 'fixed',
                bottom: 0,
                insetInlineStart: 0,
                insetInlineEnd: 0,
                zIndex: 1200,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1.5,
                px: 2,
                py: 1.25,
                bgcolor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'borders.default',
                boxShadow: 3,
                // Clears the home indicator on iOS.
                pb: 'calc(10px + env(safe-area-inset-bottom))'
            }}
        >
            <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: '0.688rem', color: 'textColors.subheading', lineHeight: 1.3 }}>
                    {priceLabel}
                </Typography>
                <Typography
                    sx={{
                        fontSize: '1.125rem',
                        fontWeight: 700,
                        color: 'textColors.primary',
                        lineHeight: 1.2,
                        whiteSpace: 'nowrap'
                    }}
                >
                    {price}
                </Typography>
            </Box>

            <Button
                variant="contained"
                onClick={event => {
                    event.stopPropagation()
                    onCtaClick()
                }}
                sx={{ px: 2.5, py: 1, fontWeight: 700, whiteSpace: 'nowrap', flexShrink: 0 }}
            >
                {ctaLabel}
            </Button>
        </Box>
    )
}

export { MobileEnquiryBar }
export type { MobileEnquiryBarProps }
export default MobileEnquiryBar
